export class ActivityNotFoundError extends Error { }
